import React from 'react';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames';

import { Container } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import { VIEW_SELECTION } from '../managers/NavigationManager';

import '../css/LtiMainView.less';

/**
 * LtiMainView - Fallback landing page for LTI contexts
 *
 * Serve as a fallback landing page for cases where MainView needs to display content/messaging
 * to the user instead of normal LTI views (e.g., unauthorized, errors, loading states).
 * Maintains the full MainView structure with LtiTopNav and displays centered content.
 *
 * @param {string} message - Content to display to the user
 *
 * @example
 * // Show unauthorized status
 * <LtiMainView message={t('unauthorized')} />
 *
 * @example
 * // Show custom error
 * <LtiMainView message="LTI initialization failed" />
 */
export default
@inject('userManager')
@observer
class LtiMainView extends React.Component {
  constructor(props) {
    super(props);
    this.LtiTopNav = SatCoreComponent('LtiTopNav');
  }

  render() {
    const { message, userManager } = this.props;
    const { LtiTopNav } = this;

    return (
      <Container className='fullHeight main-view lti-main-view' fluid>
        <LtiTopNav />
        <Container
          className={classNames('content-area', 'lti-content-area', userManager.activePermissionId)}
          fluid
          id='main-content'
          tabIndex={0}>
          <div className={`nav-separator ${VIEW_SELECTION.LTI_CONTENT_PICKER}`} />
          <main className='main-view-routes' role='main'>
            <div className='lti-status-container'>
              <div className='lti-status-message'>{message}</div>
            </div>
          </main>
        </Container>
      </Container>
    );
  }
}

SatCoreRegister('LtiMainView', LtiMainView);
